module.exports = __webpack_public_path__ + "static/media/add_data.53dad974.svg";